import device from "@/utils/device";
import Cookies from 'js-cookie';
import store from "@/store";
import Storage from '@/utils/storage';

export const beforeEnterPayRouter = (to, from, next) => {
  if (self.frameElement && self.frameElement.tagName == "IFRAME") {
    return next();
  }
  const webConfig = store.getters.webConfig;
  const token = Cookies.get('token') || Storage.get('token');

  if (!token) {
    return next();
  }

  if (localStorage.getItem("PAY_OPENID")) {
    return next();
  }

  if ("openid" in to.query) {
    localStorage.setItem("PAY_OPENID", to.query.openid);
    return next();
  }

  if (device.isWechat && !device.isComWx && !device.isMiniProgram) {
    const url = `https://${webConfig.url}/odd${to.fullPath}`;
    // console.log(url);
    location.href = `/api/v1/login/wx/h5?scope=snsapi_base&action=get-open-id&redirect_url=${url}`;
  } else {
    next();
  }
};
